import { Link } from "react-router-dom";
import Logo from "../../asset/images/home/Logo (1).png"; // adjust path if needed

function PaymentDetail() {
    return (
        <>
            {/* Header */}
            <header className="bg-white shadow-md">
                <div className="max-w-7xl mx-auto px-6 py-6">
                    <div className="flex justify-between items-center">
                        {/* Logo */}
                        <div className="flex items-center">
                            <img
                                src={Logo}
                                alt="READ 21 Logo"
                                className="h-16 w-auto"
                            />
                        </div>

                        {/* Navigation */}
                        <div className="flex items-center space-x-8">
                            <Link
                                to="/about"
                                className="bg-transparent text-gray-700 px-8 py-3 rounded-md font-medium text-lg
                                hover:bg-primaryDark hover:text-white transition-colors"
                            >
                                About
                            </Link>

                            <Link to="/register">
                                <button className="bg-primary text-white px-8 py-3 rounded-md font-medium hover:bg-primaryDark transition-colors text-lg">
                                    Enroll Today
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
            </header>

            {/* Main Section */}
            <section className="py-12">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="bg-white rounded-xl shadow-xl p-10">
                        <div className="space-y-5">
                            <div className="mb-12">
                                <h1 className="text-3xl font-bold text-primary text-center mb-10">
                                    Payment Details
                                </h1>

                                {/* Stepper */}
                                <div className="relative flex items-center justify-between max-w-2xl mx-auto">
                                    <div className="absolute left-[7%] right-[7%] top-4 h-0.5 bg-gray-300 z-0"></div>

                                    {/* Step 1 */}
                                    <div className="flex flex-col items-center relative z-10">
                                        <div className="w-8 h-8 rounded-full bg-white border-2 border-primary flex items-center justify-center mb-2">
                                            <svg
                                                className="w-5 h-5 text-primary"
                                                fill="currentColor"
                                                viewBox="0 0 20 20"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                    clipRule="evenodd"
                                                />
                                            </svg>
                                        </div>
                                        <span className="text-sm text-primary">Registration</span>
                                    </div>

                                    {/* Step 2 */}
                                    <div className="flex flex-col items-center relative z-10">
                                        <div className="w-8 h-8 rounded-full bg-white border-2 border-primary flex items-center justify-center mb-2">
                                            <svg
                                                className="w-5 h-5 text-primary"
                                                fill="currentColor"
                                                viewBox="0 0 20 20"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                    clipRule="evenodd"
                                                />
                                            </svg>
                                        </div>
                                        <span className="text-sm text-primary">Payment</span>
                                    </div>

                                    {/* Step 3 */}
                                    <div className="flex flex-col items-center relative z-10">
                                        <div className="w-8 h-8 rounded-full bg-white border-2 border-primary flex items-center justify-center mb-2">
                                            <svg
                                                className="w-5 h-5 text-primary"
                                                fill="currentColor"
                                                viewBox="0 0 20 20"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                    clipRule="evenodd"
                                                />
                                            </svg>
                                        </div>
                                        <span className="text-sm text-primary">Complete</span>
                                    </div>
                                </div>
                            </div>

                            <p className="text-center px-4 md:px-12 lg:px-24 xl:px-32">
                                Congratulations! Your payment has been successfully confirmed.
                                Please log in to start your learning journey. We're excited to have
                                you with us. Happy learning!
                            </p>

                            <center>
                                <Link to="/login">
                                    <button className="mt-5 bg-gradient-to-b from-green to-greenDark text-white py-3 px-12 rounded-xl font-bold hover:from-green-500 hover:to-green-700 transition-all duration-200 shadow-xl">
                                        Log in
                                    </button>
                                </Link>
                            </center>
                        </div>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="bg-primary py-10">
                <div className="max-w-7xl mx-auto px-6 text-center">
                    <div className="mb-3">
                        <img
                            src={Logo}
                            alt="READ 21 Logo"
                            className="mx-auto h-16 w-auto"
                        />
                    </div>
                    <p className="text-white text-lg">Read 21 © 2025 - All Rights Reserved</p>
                </div>
            </footer>
        </>
    );
}

export default PaymentDetail;
